import axios from "axios";
export default {
  namespaced: true,
  state: {
    quotations: [],
  },
  getters: {
    quotations(state) {
      return state.quotations;
    },
  },
  mutations: {
    SET_QUOTATIONS(state, quotations) {
      state.quotations = quotations;
    },
    ADD_QUOTATION(state, quotation) {
      quotation.quotation_mode = quotation.quotation_mode || "walk_in";
      quotation.is_draft = Boolean(quotation.is_draft);
      state.quotations.unshift(quotation);
    },
    EDIT_QUOTATION(state, quotation) {
      quotation.quotation_mode = quotation.quotation_mode || "walk_in";
      quotation.is_draft = Boolean(quotation.is_draft);
      var index = state.quotations.findIndex((a) => a.id == quotation.id);
      state.quotations.splice(index, 1, quotation);
    },
    TOGGLE_PIN_QUOTATION(state, quotation) {
      var index = state.quotations.findIndex((a) => a.id == quotation.id);
      if (index !== -1) {
        quotation.quotation_mode = quotation.quotation_mode || "walk_in";
        quotation.is_draft = Boolean(quotation.is_draft);
        quotation.is_pinned = Boolean(quotation.is_pinned);
        state.quotations.splice(index, 1, quotation);
      }
    },
    DELETE_QUOTATION(state, quotation) {
      let filtered = state.quotations.filter((c) => {
        return c.id != quotation.id;
      });
      state.quotations = filtered;
    },
  },
  actions: {
    // get quotations
    async get_quotations({ commit }) {
      let response = await axios.get("/quotations");
      // Normalize: ensure every quotation has a quotation_mode (default to 'walk_in' for pre-migration data)
      const normalized = response.data.map((q) => ({
        ...q,
        quotation_mode: q.quotation_mode || "walk_in",
        is_draft: Boolean(q.is_draft),
        is_pinned: Boolean(q.is_pinned),
      }));
      commit("SET_QUOTATIONS", normalized);
    },
    async add_quotation({ commit }, request) {
      let response = await axios.post("/quotation", request);
      commit("ADD_QUOTATION", response.data);
      return response.data;
    },
    async edit_quotation({ commit }, request) {
      let response = await axios.put("/quotation", request);
      commit("EDIT_QUOTATION", response.data);
    },
    async toggle_pin_quotation({ commit }, quotation) {
      let response = await axios.patch(
        "/quotation/" + quotation.id + "/toggle-pin"
      );
      commit("TOGGLE_PIN_QUOTATION", response.data);
      return response.data;
    },
    async duplicate_quotation({ commit }, quotation) {
      let response = await axios.post(
        "/quotation/" + quotation.id + "/duplicate"
      );
      commit("ADD_QUOTATION", response.data);
      return response.data;
    },
    async delete_quotation({ commit }, request) {
      await axios.delete("/quotation/" + request.id);
      commit("DELETE_QUOTATION", request);
    },
  },
};
